import { createSelector } from 'reselect';
import precise from '../modules/precise';

const transferFeeSel = state => state.registration.transferFee;
const mobileHomeLengthSel = state => state.mobilehome.mobileHomeLength;

const transferFeeSelector = createSelector(
  [transferFeeSel, mobileHomeLengthSel],
  (transferFee, mobileHomeLength) => {
    return precise(Number(transferFee) * mobileHomeLength);
  },
);

export default transferFeeSelector;
